import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import { LargeButton, ButtonType, Button } from '@checkmarx/cx-ui';


const MainPortalWrapper = require('./components/portal/mainPortalWrapper').default;

LargeButton.defaultProps = {
	buttonType:ButtonType.blue
}
Button.defaultProps = {
	buttonType:ButtonType.blue
}

window.onload = function () {
    
    const render = Component => {
        ReactDOM.render(
            <AppContainer>
                <Component />
            </AppContainer>,
            document.getElementById('root')
        );
    };   
    render(MainPortalWrapper);

    // webpack Hot Module Replacement API
    if (module.hot) {
            module.hot.accept('./components/portal/mainPortalWrapper', () => {
                const MainPortalWrapper = require('./components/portal/mainPortalWrapper').default;
                render(MainPortalWrapper);
        });
    }

};


// WEBPACK FOOTER //
// ./src/app.js